module.exports = __webpack_public_path__ + "static/img/guoji_bg.96dbda1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guoji_bg.png
// module id = TNK+
// module chunks = 27